import {ColumnPropertyLazySelect, SelectData} from "../../../../types/records-table.types";

export const videoScoreSelectData: Array<SelectData> = Array.from({ length: 10 }, (_, index) => {
  const number = index + 1;
  return {
    id: number,
    value: `${number.toString()}/10`,
    display: true,
    color: null
  };
});

export const contentForDistributionTypePropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'ContentForDistributionType',
  providerType: 'DEFAULT'
}

export const contentForVideoTypePropertyLazy: ColumnPropertyLazySelect = {
  recourseName: 'VideoType',
  providerType: 'DEFAULT'
}
